export const COMMON_ERROR = {
  // 99: Common Error / System Error
  INTERNAL_SERVER_ERROR: {
    status: 500,
    sys_code: '9900000', // 99: Common Error, 0: Internal Error, 0001: Error no
    message: 'Internal Server Error'
  },
  FORBIDDEN: {
    status: 403,
    sys_code: '9900001',
    message: 'Forbidden'
  },
  RATE_LIMIT_EXCEEDED: {
    status: 429,
    sys_code: '9900002',
    message: 'Rate limit exceeded'
  },
  MISSING_FIELD: {
    status: 400,
    sys_code: '9901000',
    message: 'Missing required field'
  },
  FILE_UPLOAD_FAIL: {
    status: 500,
    sys_code: '9901001',
    message: 'Upload file failed'
  },
  INVALID_TOKEN: {
    status: 401,
    sys_code: '9901002',
    message: 'Invalid token'
  },
  TOKEN_EXPIRED: {
    status: 401,
    sys_code: '9901003',
    message: 'Token expired'
  },
  PAGE_NOT_FOUND: {
    status: 404,
    sys_code: '9902000',
    message: 'Page not found'
  },
  FAIL_TO_SEND_EMAIL: {
    status: 500,
    sys_code: '9902001',
    message: 'Fail to send email'
  }
};
